import MetaDataFieldIndex from '@pages/meta-data-fields/MetaDataFieldIndex'
import { beforeRouteEnterAction } from '@router/router.utils'

export default [
  {
    path: '/meta-data-fields',
    name: 'meta-data-fields',
    component: MetaDataFieldIndex,
    meta: {
      requiresAuth: true,
      actions: ['metaDataFields/getSupportingData', 'metaDataFields/getAll'],
      pageTitle: 'Metadata Fields',
      pathToLocalization: 'metaDataFields.title' // TODO: replace this
    },
    beforeEnter: beforeRouteEnterAction
  }
]
